import { useKeycloak } from "@react-keycloak/web";
import React, { useState } from "react";
import airportLogo from "../../assets/images/airport-logo.png";
import appLogo from "../../assets/images/app-logo.svg";
import logoutIcon from "../../assets/images/logout_icon.svg";
import personIcon from "../../assets/images/person_icon.svg";
import useLandingAuthApi from "../../services/api/useLandingAuthApi";
import "../css/TopHeader.css";
import LogoutConfirmationDialog from "./LogoutConfirmationDialog";
import ProfileDialog from "./ProfileDialog";

const TopHeader = () => {
  const { keycloak } = useKeycloak();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { removeDeviceToken } = useLandingAuthApi();
  const [isProfileDialogOpen, setIsProfileDialogOpen] = useState(false);

  const handleLogout = async () => {
    setIsLoading(true);
    const tasks = [Promise.resolve(keycloak.logout())];

    if (typeof Notification !== "undefined" && Notification.requestPermission) {
      tasks.push(
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            return removeDeviceToken();
          }
          return undefined;
        })
      );
    }

    await Promise.allSettled(tasks);
  };

  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);

  const openProfileDialog = () => setIsProfileDialogOpen(true);
  const closeProfileDialog = () => setIsProfileDialogOpen(false);

  return (
    <div className="header-container">
      <div className="left-container-title">
        <h1>Landing Authorization</h1>
      </div>
      <div className="header-content-wrapper">
        <div className="top-header-center-container">
          <img
            src={airportLogo}
            className="top-header-left-logo"
            alt="airport logo"
          />
          <div className="top-header-vertical-line"></div>
          <img src={appLogo} className="top-header-right-logo" alt="app logo" />
        </div>
        <div className="header-buttons">
          <button className="profile-button" onClick={openProfileDialog}>
            <img src={personIcon} alt="profile icon" className="profile-icon" />
            <span>Profile</span>
          </button>
          <button className="logout-button" onClick={openDialog}>
            <img src={logoutIcon} alt="logout icon" className="logout-icon" />
            <span>Logout</span>
          </button>
        </div>
      </div>
      <LogoutConfirmationDialog
        open={isDialogOpen}
        onClose={closeDialog}
        onSave={handleLogout}
        isLoading={isLoading}
      />
      <ProfileDialog open={isProfileDialogOpen} onClose={closeProfileDialog} />
    </div>
  );
};

export default TopHeader;
